{
  "version_info": {
    "major": 2026,
    "minor": 18,
   "git_hash" : "9ff8422f"
  }
}
